import Vue from 'vue'
import VueRouter from 'vue-router'
import Acl from 'vue-acl'

Vue.use(VueRouter)
let router = new VueRouter({
  mode: 'history',

  routes: [
    // unauthenticated
    {
      name: 'login',
      path: '/',
      component: require('@components/views/login/login.vue').default,
      meta: { permission: 'any' },
    },

    {
      name: 'registro',
      path: '/registro',
      component: require('@components/views/login/registro.vue').default,
      meta: { permission: 'any' },
      fail: '/'
    },

    // secured
    {
      name: 'home',
      path: '/home',
      component: require('@components/views/home/home.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    // {
    //   name: 'realizarPedido',
    //   path: '/RealizarPedido',
    //   component: require('@components/views/realizarPedido/realizarPedido.vue').default,
    //   meta: { permission: 'user|seller' },
    //   fail: '/'
    // },

    {
      name: 'realizarPedidoCat',
      path: '/RealizarPedidoCat',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPedidoSubcat',
      path: '/RealizarPedidoSubcat',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPedidoProd',
      path: '/RealizarPedidoProd',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },



    {
      name: 'pedido',
      path: '/Pedido',
      component: require('@components/views/pedido/pedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'estadoPedido',
      path: '/EstadoPedido',
      component: require('@components/views/estadoPedido/estadoPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'pedidoCms',
      path: '/PedidoCms',
      component: require('@components/views/estadoPedido/pedidoCms.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'promociones',
      path: '/Promociones',
      component: require('@components/views/promociones/promociones.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'descuentos',
      path: '/Descuentos',
      component: require('@components/views/descuentos/descuentos.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'reload',
      path: '/reload',
      component: require('@components/views/pedido/reload.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'configuracion',
      path: '/Configuracion',
      component: require('@components/views/home/configuracion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },
    {
      name: 'ctacte',
      path: '/ctacte',
      component: require('@components/views/ctacte/index.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },
    {
      name: 'comprobante',
      path: '/ctacte/:comprobante',
      component: require('@components/views/ctacte/comprobante.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },
    {
      name: 'clientes',
      path: '/clientes',
      component: require('@components/views/preselect/clientes.vue').default,
      meta: { permission: 'seller' },
      fail: '/'
    },
    {
      name: 'depositos',
      path: '/depositos',
      component: require('@components/views/preselect/depositos.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },
    {
      name: 'reloadProductos',
      path: '/reloadProductos',
      component: require('@components/views/realizarPedido/reload.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },



    // {
    //   name: 'giras',
    //   path: '/giras',
    //   component: require('@components/views/giras/index.vue').default,
    //   meta: { permission: 'seller' },
    //   fail: '/'
    // }
  ]
})

Vue.use(Acl, {
  router,
  init: 'any'
})

export default router



// WEBPACK FOOTER //
// ./src/config/router.js